import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { href: "/" }
const _hoisted_2 = {
  key: 0,
  d: "M44.6789 11.5323C35.1132 11.5323 29.2356 18.3306 29.2356 27.033C29.2356 34.9261 34.9409 42.5912 45.5439 42.5912C46.0841 42.5912 46.6063 42.566 47.116 42.5248C47.0263 43.2588 46.9796 44.009 46.9796 44.7753C46.9796 52.6701 52.6831 60.3334 63.2861 60.3334C71.181 60.3334 75.9638 55.608 75.9638 55.608L71.9868 48.9246C71.9868 48.9246 68.3579 52.0348 64.0938 52.0348C60.9243 52.0348 57.3296 50.3639 56.5794 46.6184H75.9064C75.9064 46.6184 76.1361 44.603 76.1361 43.6231C76.1361 35.3819 71.181 29.2746 62.4229 29.2746C56.8881 29.2746 53.8838 31.4498 51.0177 32.9358C49.5353 33.7039 48.0888 34.2925 46.3497 34.2925C43.1803 34.2925 39.7865 32.6217 39.0364 28.8762H53.541C54.8978 28.2283 56.4574 27.6378 58.3203 27.2628C58.3615 26.7638 58.3938 26.2488 58.3938 25.8791C58.3938 17.6397 53.4369 11.5323 44.6789 11.5323ZM39.3253 22.8263C40.0234 20.4124 42.0084 18.6357 45.1832 18.6357C47.4678 18.6357 49.0561 20.7947 49.0561 22.8263H39.3253ZM56.8684 40.5685C57.5521 38.2032 59.7075 36.4623 62.8177 36.4623C65.0575 36.4623 66.6135 38.5764 66.6135 40.5685H56.8684Z"
}
const _hoisted_3 = {
  key: 0,
  d: "M96.7638 11.4948C90.4824 11.4948 87.8891 15.2995 87.8891 15.2995H87.7742V14.7808C87.7742 13.512 86.7943 12.1875 83.9139 12.1875H78.7847V46.6131H88.7541V42.5536C88.7541 41.0568 88.6375 40.0195 88.6375 40.0195H88.7541C88.7541 40.0195 91.4623 42.5536 96.3026 42.5536C104.196 42.5536 110.132 36.4463 110.132 27.0529C110.132 17.8336 104.831 11.4948 96.7638 11.4948ZM94.2854 34.3142C90.3675 34.3142 88.4652 30.7984 88.4652 27.227C88.4652 22.0977 91.2882 19.9082 94.2854 19.9082C97.7419 19.9082 100.106 22.7905 100.106 27.227C100.106 31.7783 97.3973 34.3142 94.2854 34.3142Z"
}
const _hoisted_4 = {
  key: 0,
  d: "M128.258 11.4955C118.693 11.4955 112.815 18.2955 112.815 26.9962C112.815 34.891 118.518 42.5543 129.121 42.5543C137.016 42.5543 141.799 37.8289 141.799 37.8289L137.822 31.1455C137.822 31.1455 134.193 34.2557 129.929 34.2557C126.76 34.2557 123.364 32.5848 122.616 28.8393H141.742C141.742 28.8393 141.971 26.8221 141.971 25.844C141.971 17.6028 137.016 11.4955 128.258 11.4955ZM122.903 22.7894C123.624 20.2966 125.663 18.4607 128.942 18.4607C131.304 18.4607 132.944 20.6897 132.944 22.7894H122.903Z"
}
const _hoisted_5 = {
  key: 0,
  d: "M164.536 11.6694C160.1 11.6694 156.354 15.0111 155.085 19.0456H154.97C154.97 19.0456 155.085 18.4695 155.085 17.547V15.991C155.085 13.2829 153.587 12.1881 150.879 12.1881H145.523V41.8632H155.489V30.6267C155.489 29.0133 155.661 27.6888 156.008 26.594C157.449 22.1576 161.309 21.4074 163.671 21.4074C164.882 21.4074 165.688 21.5797 165.688 21.5797V11.7843C165.688 11.7843 165.112 11.6694 164.536 11.6694Z"
}
const _hoisted_6 = {
  key: 0,
  d: "M180.196 11.4955C173.914 11.4955 167.979 14.2611 167.979 20.6574C167.979 30.2804 182.846 31.0881 182.846 33.5647C182.846 34.602 182.039 35.0059 180.599 35.0059C176.046 35.0059 171.899 30.7417 171.899 30.7417L167.46 37.1379C167.46 37.1379 172.071 42.5543 180.599 42.5543C187.514 42.5543 192.757 38.9236 192.757 32.9312C192.757 22.9617 177.717 23.3655 177.717 20.3128C177.717 19.3903 178.986 18.9291 180.368 18.9291C181.809 18.9291 183.076 19.5052 183.076 20.3128V21.7521H191.721V18.2381C191.721 12.8792 185.036 11.4955 180.196 11.4955Z"
}

import type { HTMLAttributes } from 'vue';
    import { useSidebar } from '@/components/ui/sidebar/utils';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'KeepersNavLogo',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

    const { open, openMobile } = useSidebar();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: 108,
      viewBox: "0 0 193 61",
      fill: "#FFFFFF",
      class: _normalizeClass(_ctx.className)
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("path", { d: "M6.52494 0.666626H0.762207V41.8672H10.7317V30.3417H11.5967C12.3451 30.3417 13.4399 30.3417 13.9585 31.3216L18.5224 39.6203C19.5005 41.5208 20.6527 41.8672 22.7848 41.8672H30.335L23.639 28.6709C22.6017 26.6555 21.3921 26.1942 21.3921 26.1942V26.0794C21.3921 26.0794 22.4869 25.5015 23.5816 23.6009L30.3225 12.1921H19.4897L14.6495 21.065C14.1308 21.9875 13.1509 21.9875 12.2877 21.9875H10.7317V4.00833C10.7317 1.07043 9.46284 0.666626 6.52494 0.666626Z" }, null, -1)),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_unref(open) || _unref(openMobile))
            ? (_openBlock(), _createElementBlock("path", _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_unref(open) || _unref(openMobile))
            ? (_openBlock(), _createElementBlock("path", _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_unref(open) || _unref(openMobile))
            ? (_openBlock(), _createElementBlock("path", _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_unref(open) || _unref(openMobile))
            ? (_openBlock(), _createElementBlock("path", _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_unref(open) || _unref(openMobile))
            ? (_openBlock(), _createElementBlock("path", _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2))
  ]))
}
}

})